import React from 'react';
import {
	BuiltInBaseEntityState,
	DefinitionEntityState,
	PrimitiveEntityState,
} from '@elyx-code/project-logic-tree';
import { EntityTypeIconSize } from '../../../services/editor/icons';
import EntityIcon from '../../entity-icon/EntityIcon';
import { CanvasEntityElement } from '../../../services/editor/CanvasElement';
import { EditorService } from '../../../services/editor';

interface IDefinitionEntityIconProps {
	entity: DefinitionEntityState | BuiltInBaseEntityState | PrimitiveEntityState;
	size?: EntityTypeIconSize;
	project?: EditorService;
	canvasElement?: CanvasEntityElement;
}

const DefinitionEntityIcon: React.FC<IDefinitionEntityIconProps> = ({
	entity,
	size = 'medium',
	project,
	canvasElement,
}) => {
	return (
		<EntityIcon
			entity={entity}
			size={size}
			className={`definition-entity-icon definition-entity-icon-${size}`}
			project={project}
			parentCanvasObject={canvasElement?.draggableObject}
		/>
	);
};

export default DefinitionEntityIcon;
